import { SourceTypeEnum } from "@/types/common";
import { OrderItemV2 } from "@/types/inventoryV2";

export const getSourceNumber = (item: OrderItemV2 | null | undefined) => {
  if (!!!item) return "";
  if (item.sourceType === SourceTypeEnum.PURCHASE_ITEM) return item?.source?.number ?? '';
  if (item.sourceType === SourceTypeEnum.REQUIREMENT_ITEM) return item?.source?.requirement?.number ?? '';
  if (item.sourceType === SourceTypeEnum.SALE_ITEM) return item?.source?.order?.number ?? '';
  return "";
}